class checkStreamsSettingCtrl {
    constructor($scope, logger, httpRequest, $state) {
        $scope.dictData = {}
        $scope.dictData.approve_type = [
            { enumTypeCode: null, enumName: '或签', enumCode: '1' },
            { enumTypeCode: null, enumName: '会签', enumCode: '2' },
        ]
        $scope.dictData.inform_type = [
            { enumTypeCode: null, enumName: '邮件通知', enumCode: 'email' },
            { enumTypeCode: null, enumName: '系统消息', enumCode: 'message' },
        ]
        $scope.dictData.compare_type = [
            { enumTypeCode: null, enumName: '介于两个值之间', enumCode: '9' },
            { enumTypeCode: null, enumName: '或', enumCode: '8' },
            { enumTypeCode: null, enumName: '>', enumCode: '1' },
            { enumTypeCode: null, enumName: '<', enumCode: '2' },
            { enumTypeCode: null, enumName: '=', enumCode: '3' },
            { enumTypeCode: null, enumName: '>=', enumCode: '4' },
            { enumTypeCode: null, enumName: '<=', enumCode: '5' },
            { enumTypeCode: null, enumName: '!=', enumCode: '6' },
            { enumTypeCode: null, enumName: 'equal', enumCode: '7' },
        ]
        $scope.dictData.compare_type_money = [
            { enumTypeCode: null, enumName: '介于两个值之间', enumCode: '9' },
            { enumTypeCode: null, enumName: '>', enumCode: '1' },
            { enumTypeCode: null, enumName: '<', enumCode: '2' },
            { enumTypeCode: null, enumName: '=', enumCode: '3' },
            { enumTypeCode: null, enumName: '>=', enumCode: '4' },
            { enumTypeCode: null, enumName: '<=', enumCode: '5' },
            { enumTypeCode: null, enumName: '!=', enumCode: '6' },
        ]
        const typecodeArr = '["inv_type","invoice_nature","zsxm_dm"]'
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.isOnSubmit = false // 完成按钮是否是禁用的状态
        const _approveCode = $state.params.id
        if (_approveCode === undefined || _approveCode === '') {
            $state.go('system.settingcenter.checkStreams.list')
        }
        // 报销类型
        $scope.reimburseType = []
        httpRequest.get_getIvatBxPzDTOList(false).then((res) => {
            const allType = res.data.value
            for (let i = 0; i < allType.length; i++) {
                const obj = {
                    enumName: allType[i].expenseName,
                    enumCode: allType[i].confId,
                }
                $scope.reimburseType.push(obj)
            }
        })
        // 查询某一审核类型分支列表
        function init() {
            httpRequest.get_qryApproveBranchList({
                approveCode: _approveCode,
            }).then((res) => {
                $scope.param = $.extend({}, $scope.param, res.data.value)
                // 组装文本
                for (let i = 0, l = $scope.param.branchList.length; i < l; i++) {
                    const _ruleList = $scope.param.branchList[i].ruleList
                    const _ruleListLen = _ruleList.length
                    // 条件
                    if (_ruleListLen > 0) {
                        for (let a = 0; a < _ruleListLen; a++) {
                            // 发票类型
                            if (_ruleList[a].fieldCode === 'invoice_type') {
                                const _invoiceType = $scope.param.branchList[i].ruleList[a].refValue
                                let _invoiceTypeArr = []
                                if (_invoiceType !== '') {
                                    _invoiceTypeArr = _invoiceType.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].invoiceTypeArr = _invoiceTypeArr
                            }

                            // 发票性质invoiceNature
                            if (_ruleList[a].fieldCode === 'invoice_nature') {
                                const _invoiceNature = $scope.param.branchList[i].ruleList[a].refValue
                                let _invoiceNatureArr = []
                                if (_invoiceNature !== '') {
                                    _invoiceNatureArr = _invoiceNature.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].invoiceNatureArr = _invoiceNatureArr
                            }

                            // 税额jxzc_se
                            if (_ruleList[a].fieldCode === 'jxzc_se') {
                                const _jxzcSe = $scope.param.branchList[i].ruleList[a].refValue
                                let _jxzcSeArr = []
                                if (_jxzcSe !== '') {
                                    _jxzcSeArr = _jxzcSe.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].jxzcSeArr = _jxzcSeArr
                            }

                            // 税种zsxm_dm
                            if (_ruleList[a].fieldCode === 'zsxm_dm') {
                                const _zsxmDm = $scope.param.branchList[i].ruleList[a].refValue
                                let _zsxmDmArr = []
                                if (_zsxmDm !== '') {
                                    _zsxmDmArr = _zsxmDm.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].zsxmDmArr = _zsxmDmArr
                                console.log(_zsxmDmArr, _zsxmDm)
                            }

                            // 发票金额 invoiceMoney
                            if (_ruleList[a].fieldCode === 'invoice_money') {
                                const _invoiceMoney = $scope.param.branchList[i].ruleList[a].refValue
                                let _invoiceMoneyArr = []
                                if (_invoiceMoney !== '') {
                                    _invoiceMoneyArr = _invoiceMoney.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].invoiceMoneyArr = _invoiceMoneyArr
                            }
                            // 应纳税额 sbse
                            if (_ruleList[a].fieldCode === 'sbse') {
                                const _sbse = $scope.param.branchList[i].ruleList[a].refValue
                                let _sbseArr = []
                                if (_sbse !== '') {
                                    _sbseArr = _sbse.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].sbseArr = _sbseArr
                            }
                            // 进项转出类型
                            // if (_ruleList[a].fieldCode === 'jxzc_lx') {
                            //     const _sbse = $scope.param.branchList[i].ruleList[a].refValue
                            //     if (_sbse !== '') {
                            //         ((a) => {
                            //             httpRequest.get_qryCategoryByIds({ categoryIds: _sbse }).then((res) => {
                            //                 $scope.param.branchList[i].ruleList[a].jxzcLxArr = res.data.value
                            //             })
                            //         })(a)
                            //     }
                            // }
                            // 部门
                            if (_ruleList[a].fieldCode === 'department_name') {
                                const _bm = $scope.param.branchList[i].ruleList[a].refValue
                                let _bmArr = []
                                if (_bm !== '') {
                                    _bmArr = _bm.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].bmArr = _bmArr
                            }
                            // 部门
                            if (_ruleList[a].fieldCode === 'conf_id') {
                                const _confid = $scope.param.branchList[i].ruleList[a].refValue
                                let _confidArr = []
                                if (_confid !== '') {
                                    _confidArr = _confid.split(',')
                                }
                                $scope.param.branchList[i].ruleList[a].confIdArr = _confidArr
                            }
                        }
                    }
                }
            })
        }
        init()
        // 删除规则分支
        $scope.operatedMinus = function (item, $index) {
            logger.logMsg({
                title: '删除确认',
                btn: ['确定', '取消'], // 按钮
                icon: 'tishi',
                message: '确认删除该审批流程？',
                yes(index) {
                    layer.close(index)
                    httpRequest.get_delApproveBranch({
                        branchId: item.branchId,
                    }, '删除成功').then((res) => {
                        $scope.param.branchList.splice($index, 1)
                    })
                },
            })
        }

        // 添加分支
        $scope.toAddBranchRule = function () {
            $state.go('system.settingcenter.checkStreams.branchAdd', { approveCode: _approveCode })
        }

        // 修改分支
        $scope.toChangeBranchRule = function (item) {
            $state.go('system.settingcenter.checkStreams.branchEdit', {
                approveCode: _approveCode,
                branchId: item.branchId,
            })
        }
        $scope.moveList = function moveList(item, type) {
            httpRequest.get_adjustPriority({
                branchId: item.branchId,
                adjustFlag: type,
            }).then(() => {
                init()
            })
        }
    }
}

checkStreamsSettingCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state']
export default checkStreamsSettingCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/checkStreams/checkStreamsSettingCtrl.js